import type { ReactNode } from 'react';
import { TooltipTitle, Term } from './styled';
import Tooltip from '@/components/Tooltip';

export const TermTooltip = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <Tooltip openDelay={300} light title={<TooltipTitle>{title}</TooltipTitle>}>
      <Term>{children}</Term>
    </Tooltip>
  );
};
